import axios, { AxiosHeaders, InternalAxiosRequestConfig } from "axios";

export const api = axios.create({
  baseURL: window.__RUNTIME_CONFIG__?.REACT_APP_BASE_URL || "https://sandbox.api.relm.co/v1/",
});

api.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    const storedToken = sessionStorage.getItem("sessionToken");

    const headers = new AxiosHeaders(config.headers);

    if (storedToken) {
      headers.set("Authorization", `Bearer ${storedToken}`);
    }

    if (typeof window !== "undefined" && !headers.has("X-Partner-Domain")) {
      headers.set("X-Partner-Domain", window.location.hostname);
    }

    return {
      ...config,
      headers,
    };
  },
  (error) => Promise.reject(error)
);
